// import React from "react"
// import apiClient from "../../src/config/apiClient";

// export const jobApi = {
//   // Get all jobs
//   getAllJobs: () => {
//     return apiClient.get("/jobs");
//   },

//   // Get job by ID
//   getJobById: (id) => {
//     return apiClient.get(`/jobs/${id}`);
//   },

//   // Filter jobs by category
//   getJobsByCategory: (category) => {
//     if (category === "All") {
//       return apiClient.get("/jobs");
//     }
//     return apiClient.get(`/jobs?category=${category}`);
//   },

//   // Apply for a job
//   applyForJob: (jobId, applicationData) => {
//     return apiClient.post(`/jobs/${jobId}/apply`, applicationData);
//   },
// };

import apiClient from "../config/apiClient";

export const jobApi = {
  // Get all jobs (public endpoint)
  getAllJobs: async () => {
    try {
      const response = await apiClient.get("/public/jobs");
      return response;
    } catch (error) {
      console.error("Error fetching jobs:", error);
      throw error;
    }
  },

  // Get job by ID (public endpoint)
  getJobById: async (id) => {
    try {
      const response = await apiClient.get(`/jobs/${id}`);
      return response;
    } catch (error) {
      console.error(`Error fetching job ${id}:`, error);
      throw error;
    }
  },

  // Filter jobs by category (public endpoint)
  getJobsByCategory: async (category) => {
    try {
      if (category === "All") {
        const response = await apiClient.get("/jobs");
        return response;
      }
      const response = await apiClient.get(`/jobs?category=${category}`);
      return response;
    } catch (error) {
      console.error(`Error fetching jobs by category ${category}:`, error);
      throw error;
    }
  },

  // Apply for a job (protected endpoint - requires token)
  applyForJob: async (jobId, applicationData) => {
    try {
      const response = await apiClient.post(`/applications`, applicationData);
      return response;
    } catch (error) {
      console.error(`Error applying for job ${jobId}:`, error);
      throw error;
    }
  },
};